import React, { useEffect, useState } from 'react';
import { Button } from 'components';
import { AuthService } from 'services';

interface Props {
    level_id: number;
    visible: boolean;
    onClose: () => void;
}

export default function TermsModal({ level_id, visible, onClose }: Props) {
    const [terms, setTerms] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (visible && !terms) {
            getTerms();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible, level_id]);

    const getTerms = async () => {
        setLoading(true);
        try {
            const res: any = await AuthService.getTerms({ level_id });
            setTerms(res || '');
        } catch (error) {
            console.error('Error al cargar términos', error);
        } finally {
            setLoading(false);
        }
    };

    if (!visible) return null;

    return (
        <>
            <style>{`
                /* Reducimos el tamaño de los h2 que vienen del back */
                .terms-html-content h2 {
                    font-size: 16px !important; 
                    font-weight: 600 !important;
                    color: #333 !important;
                    margin-top: 15px !important;
                    margin-bottom: 8px !important;
                }
                
                /* Ajustamos el tamaño del título principal subrayado */
                .terms-html-content .center {
                    font-size: 18px !important;
                    margin-bottom: 10px !important;
                }

                /* Aseguramos que los párrafos y listas mantengan consistencia */
                .terms-html-content p, 
                .terms-html-content li {
                    font-size: 14px !important;
                    line-height: 1.5 !important;
                    color: #555 !important;
                }

                /* Reducimos el margen entre elementos de las listas */
                .terms-html-content ol, 
                .terms-html-content ul {
                    padding-left: 20px !important;
                    margin-top: 5px !important;
                }

                /* --- NUEVO: Forzamos el color verde sobreescribiendo el btn-primary de Bootstrap --- */
                .btn-terms-close {
                    background-color: #6A8E34 !important;
                    border-color: #6A8E34 !important;
                    color: white !important;
                    min-width: 160px !important;
                    font-weight: 500 !important;
                }
                .btn-terms-close:hover, .btn-terms-close:focus {
                    background-color: #58772a !important; /* Un verde un poco más oscuro para el hover */
                    border-color: #58772a !important;
                    box-shadow: none !important;
                }
            `}</style>

            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                    padding: '20px'
                }}
                onClick={onClose}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                        backgroundColor: '#FFFFFF',
                        borderRadius: '12px',
                        padding: '24px',
                        maxWidth: '650px',
                        width: '100%',
                        maxHeight: '90vh',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 10px 25px rgba(0,0,0,0.2)',
                        boxSizing: 'border-box'
                    }}
                >
                    <h3
                        style={{
                            fontWeight: '600',
                            fontSize: '22px',
                            color: '#333333',
                            marginTop: '0',
                            marginBottom: '20px',
                            textAlign: 'center',
                            borderBottom: '1px solid #EAEAEA',
                            paddingBottom: '15px',
                            flexShrink: 0
                        }}
                    >
                        Términos y condiciones
                    </h3>

                    <div
                        style={{
                            overflowY: 'auto',
                            backgroundColor: '#F9F9F9',
                            border: '1px solid #EAEAEA',
                            borderRadius: '8px',
                            padding: '20px',
                            marginBottom: '24px',
                            textAlign: 'justify',
                            flexGrow: 1
                        }}
                    >
                        {loading ? (
                            <p style={{ textAlign: 'center', color: '#888', fontStyle: 'italic' }}>
                                Cargando términos...
                            </p>
                        ) : (
                            <div
                                className="terms-html-content"
                                style={{ margin: 0, padding: 0 }}
                                dangerouslySetInnerHTML={{ __html: terms }}
                            />
                        )}
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
                        {/* NUEVO: Le pasamos nuestra clase personalizada al botón y quitamos el style inline */}
                        <Button
                            className="btn-terms-close"
                            onClick={onClose}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
}